import * as FullStory from '@fullstory/browser';
import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import { create } from '@thoughtspot/logger';
import { getBaseReleaseVersion, isFullStoryEnabled, } from '@thoughtspot/session-service';
import _ from 'lodash';
import { FETCH_PROMISE_REJECTED, FullStoryAPIEventProp, FullStoryCustomEventName, MILLISECOND_PRECISION, PRISM_ONLY, PRISM_OP_NAMES_TO_SKIP, PRISM_TOTAL, PRISM_TRACE_ID_HEADER_NAME, REQUEST_TIMEOUT_STATUS_CODE, } from './fullstory-constants';
import { isFullStoryInitialized } from './fullstory-init';
import { getLatencyFromServerTimingHeader } from './fullstory-utils';
const logger = create('FullStory Custom Event API');
export const attachFullStoryCustomEventHandler = (promise, prismOpName) => {
    if (!isFullStoryEnabled() ||
        !isFullStoryInitialized() ||
        !promise ||
        PRISM_OP_NAMES_TO_SKIP.includes(prismOpName)) {
        return;
    }
    if (!FullStory.event) {
        logger.error('Cannot send Fullstory custom event because window.FS.event is undefined');
        return;
    }
    const isDebugMode = envFlags.getValue(FLAGS.debug.name) || false;
    const startTime = performance.now();
    promise.then(async (response) => {
        var _a, _b, _c;
        const endTime = performance.now();
        const customEventProps = {
            [FullStoryAPIEventProp.REQUEST_URL]: response.url,
            [FullStoryAPIEventProp.PRISM_OP_NAME]: prismOpName,
            [FullStoryAPIEventProp.RESPONSE_STATUS]: response.status,
            [FullStoryAPIEventProp.DURATION_MS]: _.round(endTime - startTime, MILLISECOND_PRECISION),
            [FullStoryAPIEventProp.PRISM_TRACE_ID]: response.headers.get(PRISM_TRACE_ID_HEADER_NAME),
            [FullStoryAPIEventProp.PRISM_ONLY_LATENCY_MS]: getLatencyFromServerTimingHeader(response.headers.get('Server-timing'), PRISM_ONLY),
            [FullStoryAPIEventProp.PRISM_TOTAL_LATENCY_MS]: getLatencyFromServerTimingHeader(response.headers.get('Server-timing'), PRISM_TOTAL),
            [FullStoryAPIEventProp.RESPONSE_SIZE_BYTES]: response.headers.get('content-length')
                ? Number(response.headers.get('content-length'))
                : null,
            [FullStoryAPIEventProp.BASE_RELEASE_VER]: getBaseReleaseVersion(),
        };
        if (response.status !== 200) {
            try {
                const data = await response.clone().json();
                const error = ((_a = data === null || data === void 0 ? void 0 : data.errors) === null || _a === void 0 ? void 0 : _a.length) ? data === null || data === void 0 ? void 0 : data.errors[0] : {};
                customEventProps[FullStoryAPIEventProp.ERROR_DETAILS] = {
                    [FullStoryAPIEventProp.ERROR_MESSAGE]: error === null || error === void 0 ? void 0 : error.message,
                    [FullStoryAPIEventProp.ERROR_CODE]: (_b = error === null || error === void 0 ? void 0 : error.extensions) === null || _b === void 0 ? void 0 : _b.code,
                    [FullStoryAPIEventProp.ERROR_SERVICE]: (_c = error === null || error === void 0 ? void 0 : error.extensions) === null || _c === void 0 ? void 0 : _c.service,
                };
            }
            catch (e) {
                if (isDebugMode) {
                    logger.error('Error reading the response body', e);
                }
            }
        }
        FullStory.event(FullStoryCustomEventName.TS_API_REQUEST, customEventProps);
        if (isDebugMode) {
            logger.info(`\nFullStory custom event name: "${FullStoryCustomEventName.TS_API_REQUEST}"\nEvent properties:`, customEventProps);
        }
    });
    promise.catch(error => {
        const endTime = performance.now();
        const customEventProps = {
            [FullStoryAPIEventProp.REQUEST_URL]: FETCH_PROMISE_REJECTED,
            [FullStoryAPIEventProp.PRISM_OP_NAME]: prismOpName,
            [FullStoryAPIEventProp.RESPONSE_STATUS]: REQUEST_TIMEOUT_STATUS_CODE,
            [FullStoryAPIEventProp.DURATION_MS]: _.round(endTime - startTime),
            [FullStoryAPIEventProp.RESPONSE_SIZE_BYTES]: null,
        };
        FullStory.event(FullStoryCustomEventName.TS_API_REQUEST, customEventProps);
        if (isDebugMode) {
            logger.info(`(Fetch promise rejected.) \nFullStory custom event name: "${FullStoryCustomEventName.TS_API_REQUEST}"\nEvent properties:`, customEventProps);
        }
    });
};
export const sendFullStoryCustomEvent = (eventName, eventProps) => {
    if (!isFullStoryEnabled() || !isFullStoryInitialized()) {
        return;
    }
    FullStory.event(eventName, eventProps);
    const isDebugMode = envFlags.getValue(FLAGS.debug.name) || false;
    if (isDebugMode) {
        logger.info(`\nFullStory custom event name: "${eventName}"\nEvent properties:`, eventProps);
    }
};
//# sourceMappingURL=fullstory-custom-events.js.map